import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import UniverseService from '@/services/UniverseService';
import UniverseServiceStaging from '@/services/UniverseServiceStaging';

export async function getUniverseName({ commit, state, rootState }, { accountId, universeId }) {
  if (state.universe) {
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'success',
    });
    return state.universe;
  }

  const isStaging = rootState.dashboard.isStaging;

  const service = isStaging ? UniverseServiceStaging : UniverseService;

  try {
    const universe = await service.panels({ accountId, universeId });

    commit(MUTATE_MULTIPLE, [{
      property: 'universe',
      with: universe,
    }, {
      property: 'requestStatus',
      with: 'success',
    }]);

    return universe;
  } catch (e) {
    console.error(e);
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'error',
    });
  }
}
